module.exports = __webpack_public_path__ + "static/img/statusCorrectStatic.fdad5a0f.png";